// Channel is the user-facing concept (what the brief's wizard shows); ProviderType
// (src/server/providers/types.ts) is the specific implementation behind it
// (e.g. channel "sms" is currently served by the "twilio_sms" provider type).
export const CHANNELS = ['sms', 'whatsapp', 'email', 'webhook'] as const;
export type Channel = (typeof CHANNELS)[number];
